import type { Block, Document, Inline } from "./types";

/** Title from a full document: the first block that yields text. A missing
 * document (card doesn't exist) reads as "Not Found"; an existing but empty
 * card reads as "Untitled". */
export function cardTitle(doc: Document | null | undefined): string {
  if (doc == null) return "Not Found";
  const index = titleBlockIndex(doc);
  return index < 0 ? "Untitled" : blockText(doc.blocks[index]!);
}

/** This function returns the index of the block that gives the title: the first
 * block that gives text. It returns -1 when no block gives text. A collapsed
 * section shows this block. */
export function titleBlockIndex(doc: Document): number {
  return doc.blocks.findIndex((block) => blockText(block));
}

function blockText(block: Block): string {
  switch (block.kind) {
    case "paragraph":
    case "heading":
      return inlineText(block.content);
    case "code_block":
      return block.text.trim();
    case "list": {
      const first = block.items[0]?.content[0];
      return first ? blockText(first) : "";
    }
    case "view_block":
    case "card_embed":
      return "";
  }
}

function inlineText(content: Inline[]): string {
  return content
    .map((i) => (i.kind === "text" ? i.text : ""))
    .join("")
    .trim();
}
